import { Component } from '@angular/core';

@Component({
  selector: 'app-richtexttester',
  templateUrl: './richtexttester.component.html',
  styleUrls: ['./richtexttester.component.css']
})
export class RichtexttesterComponent {
  content = "<p>some text dfdfdfdfdf</p>"
  showEditor = false;
  contentChanged($event: any){
    this.content = $event
    this.showEditor = false;
  }
}
